const Footer = () => {
    return (
        <footer
        style={{
            backgroundColor: '#001319',
            color: '#FFFFFF',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100px',
            width: '100%',
        }}>
            <p>©
                <a href="https://www.montblanctransfers.com">Mont Blanc Transfers</a>
                2025
            </p>
        </footer>
    );
}

export default Footer;